/* 14 Eki (Sefa): renk kutucuğunun üstüne gelince kartın ana görseli o renge geçer; karttan çıkınca eski hâline döner */
(function () {
  if (window.__ysRenk) return; window.__ysRenk = true;
  function kart(el) { return el.closest('.product-card, .cshowcase-card'); }
  function anaGorsel(c) { return c && c.querySelector('img.product-card-main-image, .cshowcase-card__img--first img'); }
  function uygula(k) {
    var c = kart(k), img = anaGorsel(c); if (!img || !k.dataset.img) return;
    if (!img.dataset.ysOrigSrc) { img.dataset.ysOrigSrc = img.getAttribute('src') || ''; img.dataset.ysOrigSet = img.getAttribute('srcset') || ''; }
    img.setAttribute('srcset', k.dataset.srcset || ''); img.setAttribute('src', k.dataset.img);
    c.classList.add('ys-renk-secili');
    var r = k.closest('.ys-renk'); r && r.querySelectorAll('.ys-renk__k').forEach(function (x) { x.classList.toggle('is-aktif', x === k); });
  }
  function geriAl(c) {
    var img = anaGorsel(c); if (!img || !img.dataset.ysOrigSrc) return;
    img.setAttribute('srcset', img.dataset.ysOrigSet); img.setAttribute('src', img.dataset.ysOrigSrc);
    c.classList.remove('ys-renk-secili');
    var ks = c.querySelectorAll('.ys-renk__k'); ks.forEach(function (x, i) { x.classList.toggle('is-aktif', i === 0); });
  }
  /* 15 Eki (Sefa): koleksiyon kartlarında (JS ile çizilen) görseli eksik renk kutucukları — ürün bilgisi bir kez
     çekilir; renk varyantının görseli, o da yoksa (varyantlara görsel atanmamış ürünler) görseller renk sırasıyla
     gruplu kabul edilip her rengin grubunun ortasındaki görsel kullanılır (snippets/ys-renk-kutucuk.liquid ile aynı kural). */
  var onbellek = {};
  function genis(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function tamamla(r) {
    if (r.__ysTam) return; r.__ysTam = true;
    var h = r.getAttribute('data-ys-urun'); if (!h) return;
    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var p = onbellek[h] || (onbellek[h] = fetch(kok + 'products/' + encodeURIComponent(h) + '.js').then(function (x) { return x.json(); }));
    p.then(function (u) {
      var ad = (r.getAttribute('data-ys-secenek') || '').toLowerCase();
      var oi = (u.options || []).findIndex(function (o) { return (o.name || o).toString().toLowerCase() === ad; });
      if (oi < 0) return;
      var degerler = (u.options[oi].values || []);
      var gorseller = u.images || [];
      r.querySelectorAll('.ys-renk__k').forEach(function (k, i) {
        if (k.dataset.img) return;
        var deger = k.getAttribute('title'); var di = degerler.indexOf(deger); if (di < 0) di = i;
        var src = '';
        var v = (u.variants || []).filter(function (x) { return x.options[oi] === deger && x.featured_image; })[0];
        if (v) src = v.featured_image.src;
        else if (gorseller.length >= degerler.length) src = gorseller[Math.floor((di * 2 + 1) * gorseller.length / 2 / degerler.length)];
        if (!src) return;
        k.setAttribute('data-img', genis(src, 600));
        k.setAttribute('data-srcset', genis(src, 400) + ' 400w, ' + genis(src, 800) + ' 800w');
        var g = k.querySelector('.ys-renk__g');
        if (g && !g.querySelector('img')) { var im = document.createElement('img'); im.src = genis(src, 96); im.alt = ''; im.loading = 'lazy'; im.width = 48; im.height = 48; g.appendChild(im); }
      });
      r.removeAttribute('data-ys-eksik');
    }).catch(function () {});
  }
  /* eksik satırlar az (sayfa başına birkaç ürün) → tarayıcı boşta kalınca sırayla tamamlanır */
  var bosta = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
  function tara() { document.querySelectorAll('.ys-renk[data-ys-eksik]').forEach(function (r) { if (r.__ysIzle) return; r.__ysIzle = true; bosta(function () { tamamla(r); }); }); }
  var bekle = false;
  tara(); new MutationObserver(function () { if (bekle) return; bekle = true; requestAnimationFrame(function () { bekle = false; tara(); }); }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('mouseover', function (e) { var k = e.target.closest && e.target.closest('.ys-renk__k'); if (!k) return; var r = k.closest('.ys-renk[data-ys-eksik]'); if (r) tamamla(r); uygula(k); });
  document.addEventListener('focusin', function (e) { var k = e.target.closest && e.target.closest('.ys-renk__k'); if (k) uygula(k); });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('.product-card.ys-renk-secili, .cshowcase-card.ys-renk-secili'); if (!c) return;
    if (e.relatedTarget && c.contains(e.relatedTarget)) return; geriAl(c);
  });
})();
